import { useState, useEffect } from 'react';
import { Box, Heading, Text, Image, Flex, Button, useBreakpointValue, } from '@chakra-ui/react'
import { TfiArrowCircleLeft, TfiArrowCircleRight } from "react-icons/tfi";
import { DesktopPhotos, DesktopMobile } from './items/photos';
import img from "../../../assets/img/home/home3/logos.svg";
import img1 from "../../../assets/img/home/home3/logos2.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../../helpers/fontSizesByLang';

function HomeSection3() {

    const { t, i18n } = useTranslation();
    const fontSizes = fontSizesByLang[i18n.language];
    const [index, setIndex] = useState(0);

    const images = useBreakpointValue({
        base: DesktopMobile,
        md: DesktopPhotos
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (!images) return;
        if (index >= images.length) setIndex(0);
    }, [images, index]);

    if (!images) return null;



    return (
        <Flex
            id="services"
            bg={'#1E1D1D'}
            flexDirection="column"
            backgroundRepeat="no-repeat"
            backgroundSize={{ base: 'cover', md: 'cover', lg: 'cover' }}
            backgroundPosition={{ base: 'center', }}
            minHeight="100vh"
            alignItems={'center'}
        >

            <Heading
                as="h2"
                size={{ base: 'xl', md: '2xl', lg: "3xl" }}
                textAlign={{ base: 'center', md: 'center' }}
                fontFamily={'Roboto Condensed'}
                fontWeight={'black'}
                marginTop={{ base: '7%', md: '5%' }}
                color={'#FFFFFF'}
                fontSize={fontSizes.tittlefont}
                margin={{ base: '3%', md: '0%' }}
            >
                {t("whatourclients")}{" "}
                <Text as="span" color="#ae8245" display={{ base: 'block', md: 'inline' }}>
                    {t("sayaboutus")}
                </Text>
            </Heading>
            <Text
                margin={'2%'}
                textAlign={{ base: 'left', md: 'center' }}
                color="#929292"
                width={{ base: '90%', md: '80%', lg: '35%' }}
                marginTop="6"
                fontSize={fontSizes.textfont}
                fontFamily={'Inter'}
            >
                {t("clients-say-info")}
            </Text>

            {/* Carousel */}
            <Flex width="100%" justifyContent="center" alignItems="center" mt="4" gap={{base:'2', md:'5', lg:'5', xl:'7', '2xl':'0'}}>
                {/* Botón izquierdo */}
                <Button
                    onClick={() => setIndex((index - 1 + images.length) % images.length)}
                    bg="#808080"
                    borderRadius="full"
                    p="0"
                    width="1%"
                    height="auto"
                    _hover={{ bg: '#f5f5f5' }}
                >
                    <TfiArrowCircleLeft color="FFFFFF" size="100%" />
                </Button>

                {/* Imagen */}
                <Box
                    width={{ base: '50%', md: '60%', lg: '50%' }}
                    height={{ base: '200px', md: '300px', lg: '400px' }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    overflow="hidden"
                >
                    <Image
                        src={images[index]}
                        width="100%"
                        height="100%"
                        borderRadius="20px"
                        transition="all 0.5s ease"
                        objectFit="contain"
                    />
                </Box>

                {/* Botón derecho */}
                <Button
                    onClick={() => setIndex((index + 1) % images.length)}
                    bg="#808080"
                    borderRadius="full"
                    p="0"
                    width="1%"
                    height="auto"
                    _hover={{ bg: '#f5f5f5' }}
                >
                    <TfiArrowCircleRight color="#FFFFFF" size="100%" />
                </Button>
            </Flex>


            <Flex marginTop={{ base: '15%', md: '3%' }}
                justifyContent={'center'}
                width={'90%'}
            >
                <Button
                    type="button"
                    onClick={() => navigate("/contact#quote-form")}
                    width={{ base: '40%', md: '30%', lg: '10%' }}
                    fontSize="120%"
                    height="15%"
                    background="#ae8245"
                    color="white"
                    borderRadius="30px"
                    fontFamily="Inter"
                    fontWeight="medium"
                    _hover={{ bg: '#d8973bff' }}
                    padding={3}
                >
                    {t("quote")}
                </Button>
            </Flex>

            <Flex
                width={'100%'}
                flexDirection={{ base: 'column', md: 'column', lg: 'row' }}
                marginTop={'3%'}
            >
                <Flex display={{ base: 'none', md: 'flex' }} width={'100%'}>
                    <Image
                        src={img}
                        bg={'white'}
                        width='100%'
                    />
                </Flex>
                <Flex width='100%'
                    display={{ base: 'flex', md: 'none' }}
                >
                    <Image
                        src={img1}
                        bg={'white'}
                        width={{ base: '100%', md: '50%', lg: '50%' }}
                    />
                    {/* <Image
                        src={img5}
                        bg={'white'}
                        width={{ base: '100%', md: '50%', lg: '50%' }}
                    /> */}

                </Flex>
            </Flex>
        </Flex>

    )
}

export default HomeSection3
